import dynamic from 'next/dynamic';
const MobileBottomNav = dynamic(() => import('../shared/Mobile/MobileBottomNav'), { ssr: false });
const FooterComponent = dynamic(() => import('../../components/shared/Footer/FooterComponent'), { ssr: false });
import CookieConsent from '../shared/CookieConsent/CookieConsent';

export default function GuestLayout({ children, version }) {
  // decide here for app layout?
  return (
    <>
      <main>{children}</main>
      <FooterComponent />
      <MobileBottomNav version={version} />
      <CookieConsent></CookieConsent>
    </>
  );
}
